import { fetchEmployerData } from './employerData';

// SEC-003.1: reads go through the employerData function, which never uses the Sanity CDN,
// so this is now the same as client.js. Kept so existing imports don't change.
export const clientNoCdn = { fetch: fetchEmployerData };
